export default __webpack_public_path__ + "static/media/kuvantaminen-darkblue.153709d2.svg";